import React from 'react';
import {
    RideGlError,
    RideIconButton,
    RideButton,
} from '@rimac-seguros/ride-system-components';
import useBreakpoint from '@/hooks/useBreakpoint';

const Modal = props => {

    const isTablet = useBreakpoint('tablet');
    return (
        <>
            {props.active &&
                <div className={props.classModal}>
                    <div className="alert-modal" onClick={props.onClose}></div>
                    <div className="alert-modal__content">
                        <div className="alert-modal__content--btnClose-new">
                            {isTablet ?
                                <RideButton
                                    text="Cerrar"
                                    variant="text-secondary"
                                    size="large"
                                    glyph={<RideGlError />}
                                    glyphPosition="right"
                                    onClick={() => props.onClose?.()}
                                />
                                    :
                                <RideIconButton
                                    glyph={<RideGlError />}
                                    variant="unfill"
                                    size="large"
                                    onClick={() => props.onClose?.()}
                                />
                            }
                        </div>
                        {props.title &&
                            <>
                                {typeof props.title === 'string' && (props.title.indexOf('<') && props.title.indexOf('/>')) //detectar html en el string
                                    ?
                                    <div className={`alert-modal__content--header ${props.line ? ' header-line' : ''}`}
                                        dangerouslySetInnerHTML={{ __html: props.title }} />
                                    :
                                    <div className={`alert-modal__content--header ${props.line ? ' header-line' : ''}`}>
                                        {props.title}
                                    </div>
                                }
                            </>
                        }
                        <div className="alert-modal__container">
                            <div className="alert-modal__content--body">
                                {props.description &&
                                    <div
                                        className="alert-modal__content--body_description"
                                        dangerouslySetInnerHTML={{ __html: props.description }} />
                                }
                                {props.body}
                            </div>
                            {!!props.footer &&
                                <div className="alert-modal__content--footer">
                                    {props.footer.map((res, index) => {
                                        return (
                                            <button className={props.className} onClick={res.accion} key={index}>{res.title}</button>
                                        )
                                    })}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    );
};


export default Modal;
